import React, { useRef, useState } from 'react';
import imageCompression from 'browser-image-compression';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import Cropper from 'react-easy-crop';
import Modal from 'react-bootstrap/Modal';

const ImageUpload = ({ onUpload, label = 'Rasm yuklash', initialImage = null }) => {
  const fileInputRef = useRef();
  const [error, setError] = useState(null);
  const [preview, setPreview] = useState(initialImage);
  const [uploading, setUploading] = useState(false);
  const { user, token } = useAuth();
  const [showCropModal, setShowCropModal] = useState(false);
  const [cropImage, setCropImage] = useState(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

  const checkSquare = (file) => Promise.resolve(); // allow all

  // Utility function to crop image to blob (returns webp)
  const getCroppedImg = async (imageSrc, cropPixels) => {
    const image = await new Promise((resolve, reject) => {
      const img = new window.Image();
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = imageSrc;
    });
    const canvas = document.createElement('canvas');
    canvas.width = cropPixels.width;
    canvas.height = cropPixels.height;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(
      image,
      cropPixels.x,
      cropPixels.y,
      cropPixels.width,
      cropPixels.height,
      0,
      0,
      cropPixels.width,
      cropPixels.height
    );
    // Always output as webp
    return await new Promise((resolve) =>
      canvas.toBlob(resolve, 'image/webp', 0.85)
    );
  };

  const handleFileChange = async (e) => {
    setError(null);
    const file = e.target.files[0];
    if (!file) return;
    // Accept formats: png, jpg, jpeg, webp, gif, bmp, etc.
    const allowedTypes = [
      'image/png',
      'image/jpeg',
      'image/jpg',
      'image/webp',
      'image/gif',
      'image/bmp',
      'image/svg+xml',
    ];
    if (!allowedTypes.includes(file.type)) {
      setError('Faqat rasm fayli yuklang! (JPG, PNG, WEBP, GIF, BMP)');
      return;
    }
    setCropImage(URL.createObjectURL(file));
    setShowCropModal(true);
  };

  const onCropComplete = (_, croppedAreaPixelsData) => {
    setCroppedAreaPixels(croppedAreaPixelsData);
  };

  const handleCropSave = async () => {
    setUploading(true);
    try {
      const croppedBlob = await getCroppedImg(cropImage, croppedAreaPixels);
      const uploadFileName = 'image.webp';
      const formData = new FormData();
      formData.append('image', croppedBlob, uploadFileName);
      setPreview(URL.createObjectURL(croppedBlob));
      setShowCropModal(false);
      // Actually upload
      const res = await fetch('/api/upload', {
        method: 'POST',
        body: formData,
        headers: {
          ...(token ? { 'Authorization': `Bearer ${token}` } : {}),
          'X-Owner-Id': String(user?.ownerId || user?.id || ''),
          'X-Staff-Id': String(user?.staffId ?? ''),
        },
      });
      setUploading(false);
      if (!res.ok) {
        const err = await res.text();
        throw new Error(err || 'Yuklashda xatolik');
      }
      const data = await res.json();
      if (onUpload) onUpload(data.path);
    } catch (err) {
      setUploading(false);
      setError(err.message || err);
      setPreview(null);
      if (onUpload) onUpload(null);
    }
  };

  return (
    <div>
      {label && <label>{label}</label>}
      <div className="border border-2 rounded d-flex flex-column justify-content-center align-items-center p-4" style={{ height: '140px' }}>
        {preview ? (
          <img src={preview} alt="Preview" style={{ maxHeight: '100%', maxWidth: '100%', objectFit: 'contain' }} />
        ) : (
          <>
            <i className="bi bi-image" style={{ fontSize: '2rem' }}></i>
            <div>Rasm yuklash</div>
            <small className="text-muted">PNG, JPG, WEBP (kvadrat)</small>
          </>
        )}
        <input
          type="file"
          accept="image/*"
          className="form-control mt-2"
          ref={fileInputRef}
          onChange={handleFileChange}
          disabled={uploading}
        />
        {uploading && <Spinner animation="border" size="sm" className="mt-2" />}
      </div>
      {error && <Alert variant="danger" className="mt-2">{error}</Alert>}

      {/* Cropper Modal */}
      <Modal show={showCropModal} onHide={() => setShowCropModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Rasmni tartibga soling</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: 350 }}>
          {cropImage && (
            <div style={{ position: 'relative', width: '100%', height: 300, background: '#333' }}>
              <Cropper
                image={cropImage}
                crop={crop}
                zoom={zoom}
                aspect={1}
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
                cropShape="rect"
                showGrid={true}
              />
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowCropModal(false)}>Bekor qilish</Button>
          <Button variant="success" onClick={handleCropSave}>Saqlash</Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ImageUpload; 